import { Breadcrumb } from '@components/breadcrumb';
import { useFragment } from 'react-relay';
import { TypeMap, simplePageFragment } from './lib';
import type { SimplePageProps } from './types';

export const SimplePage: React.FC<SimplePageProps> = (props) => {
  const page = useFragment(simplePageFragment, props.page);

  return (
    <div>
      <Breadcrumb data={page.breadcrumbs} />
      <div className="Widget-container Base-container relative mx-auto flex w-full max-w-[820px] flex-wrap items-start justify-between max-[1100px]:mx-auto max-[1100px]:max-w-[565px] max-[1100px]:w-[calc(100vw-80px)] max-[600px]:max-w-[565px] max-[600px]:w-[calc(100vw-40px)]">
        {page.components?.edges?.map((edge) => {
          if (!edge?.node) {
            return null;
          }
          const Type = TypeMap[edge.node.__typename];
          return Type ? <Type key={edge.node.__typename} location={page.id} component={edge.node} /> : null;
        })}
      </div>
    </div>
  );
};
